<template>
    <div class="main-container">
        <div class="notice">
            <span class="iconfont icon-nengyuanzutaitu"></span>
            当前在线设备：{{total.TotalDevice-total.TotalOffDevice}}
            <i>|</i>
			<span class="warn">
            <span class="iconfont icon-nengyuanzutaitu"></span>

                当前失联设备：{{total.TotalOffDevice}}</span>
            <i>|</i>
			<span class="warn">
            <span class="iconfont icon-nengyuanzutaitu"></span>
            当前设备在线率：{{Math.round(((total.TotalDevice-total.TotalOffDevice)/total.TotalDevice)*100)}}%
            </span>
        </div>
        <div class="content">
            <div class="leftBox">
                <Card
                    title="快速工作台"
                    icon="iconfont icon-diantianquanjiankongxitong"
                >
                    <div class="word">
                        <div
                            class="wordCard"
                            v-for="item in info"
                            :key="item.ParamName"
                        >
                            <span class="title"> <span class="iconfont icon-diannengshishi icon"></span>{{item.Remark}}</span>
                            <span class="content">{{item.Value}}</span>
                        </div>
                    </div>
                </Card>
                <Card
                    title="近30天事件统计曲线"
                    icon="iconfont icon-diantianquanjiankongxitong"
                >

                    <div id="Chart"></div>
                </Card>
                <Card
                    title="事件统计"
                    icon="iconfont icon-diantianquanjiankongxitong"
                >
                    <div class="event">
                        <div
                            class="eventCard"
                            v-for="item in event"
                            :key="item.title"
                        >
                            <span class="title">{{item.title}}</span>
                            <span class="content">{{item.value}}</span>
                        </div>
                    </div>
                </Card>
            </div>
            <div class="rightBox">
                <div class="prjBox">
                    <el-form
                        :model="searchForm"
                        size="mini"
                        class="searchForm"
                    >
                        <el-form-item style="margin-bottom:0;margin-right:10px;">
                            <el-input
                                v-model="searchForm.PrjName"
                                placeholder="请输入项目名称"
                                clearable=""
                            ></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0">
                            <el-button
                                type="primary"
                                @click="getPrjList(searchForm.PrjName)"
                            >查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div
                        class="prjList"
                        v-if="prjList&&prjList.length>0"
                    >
                        <div
                            class="card"
                            v-for="item in prjList"
                            :key="item.PrjID"
                            @click="jump(item.lon,item.Lat,item.PrjName)"
                        >
                            <div class="card_logo">
                                <img
                                    src="@/assets/img/mark.png"
                                    alt="坐标LOGO"
                                >
                            </div>
                            <div class="card_content">
                                <p class="title">{{item.PrjName}}</p>
                                <p class="address">{{item.Address}}</p>
                            </div>
                        </div>
                    </div>
                    <el-empty
                        :image-size="100"
                        v-else
                    ></el-empty>
                    <!-- <button @click="jump">跳转</button> -->
                </div>
                <Map ref="map"></Map>
            </div>
            <!-- <div class="rightBox"></div> -->
        </div>
    </div>
</template>

<script>
import Card from "@/components/card";
import Map from "@/components/map";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            searchForm: {
                PrjName: "",
            },
            info: [],
            total: {},
            prjList: [],
            chart: null,
            event: [
                { title: "累计告警", value: 0 },
                { title: "上月告警", value: 0 },
                { title: "本月告警", value: 0 },
                { title: "累计隐患", value: 0 },
                { title: "上月隐患", value: 0 },
                { title: "本月隐患", value: 0 },
            ],
        };
    },
    components: { Card, Map },
    computed: {
        ...mapGetters(["SessionId", "UserId"]),
    },
    mounted() {
        window.addEventListener("resize", this.resize);
        this.getPrjList().then(() => {
            this.$refs["map"].addMaker(this.prjList);
            return this.getInfo();
        });
        this.initChart(
            "Chart",
            ["2022-10-01", "2022-10-02", "2022-10-03"],
            [[]]
        );
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resize);
    },
    methods: {
        resize() {
            this.chart.resize();
        },
        jump(lon, lat, name) {
            if (!lon || !lat) {
                this.$message.error("获取经纬度失败");
                return;
            }
            this.$refs["map"].setMapCenter(lon, lat, name);
        },
        getPrjList(PrjName) {
            let obj = {
                SessionId: this.SessionId,
                UserId: this.UserId,
                ClientName: "Hoko.Iot.Web.System",
                Params: {
                    SortList: [
                        {
                            SortDescend: true,
                            SortProperty: "CreateTime",
                        },
                    ],
                    SearchList: [],
                },
            };
            if (PrjName) {
                obj.Params.SearchList.push({
                    CompareType: "Contains",
                    PropertyName: "PrjName",
                    PropertyValue: PrjName,
                });
            }
            return new Promise((resolve) => {
                this.$api
                    .axios_http(this.$gd.admin.project.getList, obj, "POST")
                    .then((res) => {
                        if (res.ReturnCode == 0) {
                            if (PrjName) {
                                this.prjList = res.ReturnList;
                            } else {
                                this.prjList = res.ReturnList
                                    ? res.ReturnList.slice(0, 10)
                                    : [];
                            }
                            resolve();
                        } else {
                            this.$message.error(res.Error);
                        }
                    });
            });
        },
        getInfo() {
            let obj = {
                SessionId: this.SessionId,
                UserId: this.UserId,
                ClientName: "Hoko.Iot.Web.System",
                Params: {},
            };
            return new Promise((resolve) => {
                this.$api
                    .axios_http(this.$gd.admin.home.getInfo, obj, "POST")
                    .then((res) => {
                        if (res.ReturnCode == 0) {
                            this.info = res.ReturnList;
                            this.info.forEach((item) => {
                                this.total[item.ParamName] = item.Value;
                            });
                            resolve();
                        } else {
                            this.$message.error(res.Error);
                        }
                    });
            });
        },
        initChart(id, titleData, data) {
            this.chart = this.$echarts.init(document.getElementById(id));
            let seriesData = [];
            if (data) {
                data.forEach((item) => {
                    if (item) {
                        seriesData.push({
                            data: item,
                            type: "line",
                            smooth: true,
                        });
                    }
                });
            }

            // 绘制图表
            this.chart.setOption({
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: titleData,
                },
                yAxis: {
                    type: "value",
                },
                series: seriesData,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.main-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    & > .notice {
        line-height: 40px;
        text-indent: 10px;
        background: white;
        color: #2c86d1;
        margin-bottom: 10px;
        border-bottom: solid 1px #e6e6e6;
        i {
            color: #e6e6e6;
            margin: 0 10px;
            font-style: normal;
        }
        .warn {
            color: #f56c6c;
			&>span{
				color: #f56c6c;
			}
        }
    }
    & > .content {
        flex: 1;
        height: 0;
        display: flex;
        .leftBox {
            flex: 1;
            min-width: 300px;
            display: flex;
            flex-direction: column;
            #Chart {
                width: 100%;
                height: 100%;
            }
            & > div {
                margin: 10px;
                margin-top: 0;
                flex: 1;
            }
            .event {
                width: 100%;
                height: 100%;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-template-rows: repeat(2, 1fr);
                padding: 20px 0;
                box-sizing: border-box;
                .eventCard {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    & > .title {
                        font-size: 16px;
                        color: #394d62;
                        display: flex;
                        align-items: center;
                    }
                    & > .content {
                        color: #2c86d1;
                        font-size: 28px;
                        font-weight: bold;
                    }
                }
            }
            .word {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100%;
                padding: 10px 20px;
                justify-content: center;
                box-sizing: border-box;
                .wordCard {
                    border-bottom: solid 1px #e6e6e6;
                    display: flex;
                    width: 100%;
                    padding: 10px 0;
                    justify-content: space-between;
                    align-items: center;
                    &:last-child {
                        border-bottom: none;
                    }
                    & > .title {
                        color: #2c86d1;
                        font-size: 18px;
                        font-weight: bold;
                        display: flex;
                        align-items: center;
                        & > .icon {
                            font-size: 30px;
                            margin-right: 5px;
                            font-weight: normal;
                            color: #909399;
                        }
                    }
                    & > .content {
                        color: #394d62;
                        font-size: 24px;
                    }
                }
            }
        }
        .rightBox {
            flex: 5;
            margin-bottom: 10px;
            box-sizing: border-box;
            position: relative;
            .searchForm {
                display: flex;
                padding: 10px;
                justify-content: center;
            }
            .prjBox {
                position: absolute;
                background: rgba($color: white, $alpha: 0.6);
                width: 300px;
                height: calc(100% - 20px);
                margin: 10px;
                top: 0;
                right: 0;
                z-index: 10;
                box-sizing: border-box;
                border-radius: 10px;
                border: 2px solid #2c86d1;
                transition: all 0.4s;
                display: flex;
                flex-direction: column;
                &:hover {
                    background: rgba($color: white, $alpha: 0.9);
                }
                .prjList {
                    padding-bottom: 10px;
                    overflow: auto;
                    .card {
                        display: flex;
                        align-items: center;
                        border-bottom: solid 1px #e6e6e6;
                        padding: 10px 20px;
                        cursor: pointer;
                        transition: all 0.4s;
                        &:hover {
                            background: rgba($color: #e6e6e6, $alpha: 0.5);
                        }
                        .card_logo {
                            margin-right: 15px;
                        }
                        .card_content {
                            p {
                                margin: 0;
                            }
                            p.title {
                                color: #2c86d1;
                                font-weight: bold;
                                font-size: 16px;
                            }
                            p.address {
                                color: #394d62;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
